import { SvgIcon } from '@material-ui/core'
import React from 'react'

const ChartIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <g className="filled">
        <path
          fillRule="evenodd"
          d="M22 21.5C22 21.7761 21.7761 22 21.5 22L2.5 22C2.22386 22 2 21.7761 2 21.5C2 21.2239 2.22386 21 2.5 21L21.5 21C21.7761 21 22 21.2239 22 21.5Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 22C2.22386 22 2 21.7761 2 21.5L2 2.5C2 2.22386 2.22386 2 2.5 2C2.77614 2 3 2.22386 3 2.5L3 21.5C3 21.7761 2.77614 22 2.5 22Z"
        />
        <path
          fillRule="evenodd"
          d="M9 12C9.55228 12 10 11.5523 10 11C10 10.4477 9.55228 10 9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12Z"
        />
        <path
          fillRule="evenodd"
          d="M16 6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6Z"
        />
        <path
          fillRule="evenodd"
          d="M6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19Z"
        />
        <path d="M19 8.5C19 9.32843 18.3284 10 17.5 10C16.6716 10 16 9.32843 16 8.5C16 7.67157 16.6716 7 17.5 7C18.3284 7 19 7.67157 19 8.5Z" />
        <path
          fillRule="evenodd"
          d="M17.5 9C17.7761 9 18 8.77614 18 8.5C18 8.22386 17.7761 8 17.5 8C17.2239 8 17 8.22386 17 8.5C17 8.77614 17.2239 9 17.5 9ZM17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7C16.6716 7 16 7.67157 16 8.5C16 9.32843 16.6716 10 17.5 10Z"
        />
        <path d="M15 9C15 10.1046 14.1046 11 13 11C11.8954 11 11 10.1046 11 9C11 7.89543 11.8954 7 13 7C14.1046 7 15 7.89543 15 9Z" />
        <path
          fillRule="evenodd"
          d="M13 10C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10ZM13 11C14.1046 11 15 10.1046 15 9C15 7.89543 14.1046 7 13 7C11.8954 7 11 7.89543 11 9C11 10.1046 11.8954 11 13 11Z"
        />
        <path d="M11 15C11 16.1046 10.1046 17 9 17C7.89543 17 7 16.1046 7 15C7 13.8954 7.89543 13 9 13C10.1046 13 11 13.8954 11 15Z" />
        <path
          fillRule="evenodd"
          d="M9 16C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16ZM9 17C10.1046 17 11 16.1046 11 15C11 13.8954 10.1046 13 9 13C7.89543 13 7 13.8954 7 15C7 16.1046 7.89543 17 9 17Z"
        />
        <path d="M15 13.5C15 14.3284 14.3284 15 13.5 15C12.6716 15 12 14.3284 12 13.5C12 12.6716 12.6716 12 13.5 12C14.3284 12 15 12.6716 15 13.5Z" />
        <path
          fillRule="evenodd"
          d="M13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14ZM13.5 15C14.3284 15 15 14.3284 15 13.5C15 12.6716 14.3284 12 13.5 12C12.6716 12 12 12.6716 12 13.5C12 14.3284 12.6716 15 13.5 15Z"
        />
      </g>

      <g className="outline">
        <path
          fillRule="evenodd"
          d="M22 21.5C22 21.7761 21.7761 22 21.5 22L2.5 22C2.22386 22 2 21.7761 2 21.5C2 21.2239 2.22386 21 2.5 21L21.5 21C21.7761 21 22 21.2239 22 21.5Z"
        />
        <path
          fillRule="evenodd"
          d="M2.5 22C2.22386 22 2 21.7761 2 21.5L2 2.5C2 2.22386 2.22386 2 2.5 2C2.77614 2 3 2.22386 3 2.5L3 21.5C3 21.7761 2.77614 22 2.5 22Z"
        />
        <path
          fillRule="evenodd"
          d="M9 12C9.55228 12 10 11.5523 10 11C10 10.4477 9.55228 10 9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12Z"
        />
        <path
          fillRule="evenodd"
          d="M16 6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6Z"
        />
        <path
          fillRule="evenodd"
          d="M6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19Z"
        />
        <path
          fillRule="evenodd"
          d="M17.5 9C17.7761 9 18 8.77614 18 8.5C18 8.22386 17.7761 8 17.5 8C17.2239 8 17 8.22386 17 8.5C17 8.77614 17.2239 9 17.5 9ZM17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7C16.6716 7 16 7.67157 16 8.5C16 9.32843 16.6716 10 17.5 10Z"
        />
        <path
          fillRule="evenodd"
          d="M13 10C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10ZM13 11C14.1046 11 15 10.1046 15 9C15 7.89543 14.1046 7 13 7C11.8954 7 11 7.89543 11 9C11 10.1046 11.8954 11 13 11Z"
        />
        <path
          fillRule="evenodd"
          d="M9 16C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16ZM9 17C10.1046 17 11 16.1046 11 15C11 13.8954 10.1046 13 9 13C7.89543 13 7 13.8954 7 15C7 16.1046 7.89543 17 9 17Z"
        />
        <path
          fillRule="evenodd"
          d="M13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14ZM13.5 15C14.3284 15 15 14.3284 15 13.5C15 12.6716 14.3284 12 13.5 12C12.6716 12 12 12.6716 12 13.5C12 14.3284 12.6716 15 13.5 15Z"
        />
      </g>
    </SvgIcon>
  )
}

export default ChartIcon
